import { WeekDays } from '@umanforge/common';
import dayjs from 'dayjs';

export const getPreviousWeekdays = ( startDate: dayjs.Dayjs, count: number, daysToShow: WeekDays ): dayjs.Dayjs[] => {
  const result: dayjs.Dayjs[] = [];
  let date = startDate;
  while ( result.length < count ) {
    date = date.add( -1, 'day' );
    if ( isDayAllowed( date.day(), daysToShow ) ) {
      result.push( date );
    }
  }

  return result.reverse();
};

export const getUpcomingWeekdays = ( startDate: dayjs.Dayjs, count: number, daysToShow: WeekDays ): dayjs.Dayjs[] => {
  const result: dayjs.Dayjs[] = [];
  let date = startDate;
  while ( result.length < count ) {
    if ( isDayAllowed( date.day(), daysToShow ) ) {
      result.push( date );
    }
    date = date.add( 1, 'day' );
  }
  return result;
};

const isDayAllowed = ( day: number, daysToShow : WeekDays ) => {
  return (
    ( day === 0 && daysToShow && daysToShow.sunday ) ||
    ( day === 1 && daysToShow && daysToShow.monday ) ||
    ( day === 2 && daysToShow && daysToShow.tuesday ) ||
    ( day === 3 && daysToShow && daysToShow.wednesday ) ||
    ( day === 4 && daysToShow && daysToShow.thursday ) ||
    ( day === 5 && daysToShow && daysToShow.friday ) ||
    ( day === 6 && daysToShow && daysToShow.saturday )
  );
};